export default "__VITE_PUBLIC_ASSET__121de858__"